module.exports = __webpack_public_path__ + "static/media/anc1ru.8a85f390.pdf";